import { render } from "./Verpromocion.vue?vue&type=template&id=2c7ab106"
import script from "./Verpromocion.vue?vue&type=script&lang=js"
export * from "./Verpromocion.vue?vue&type=script&lang=js"

import "./Verpromocion.vue?vue&type=style&index=0&id=2c7ab106&lang=css"
import "./Verpromocion.vue?vue&type=style&index=1&id=2c7ab106&lang=css"
import "./Verpromocion.vue?vue&type=style&index=2&id=2c7ab106&lang=css"

import exportComponent from "C:\\SistemasProyectos\\AppWeb\\historiaClinica\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__